"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProOptionsPreset = void 0;
const Utils_1 = require("../../utils/Utils");
exports.ProOptionsPreset = Utils_1.Utils.makeEnum({
    Default: 'default',
    LowObfuscation: 'low-obfuscation',
    MediumObfuscation: 'medium-obfuscation',
    HighObfuscation: 'high-obfuscation',
    VMLowObfuscation: 'vm-low-obfuscation',
    VMDefault: 'vm-default',
    VMMediumObfuscation: 'vm-medium-obfuscation',
    VMHighObfuscation: 'vm-high-obfuscation',
    VMUltraHighObfuscation: 'vm-ultra-high-obfuscation',
    VMAntiLLM: 'vm-anti-llm'
});
